import api from 'service/api'

const dponetAPINotTreatError = api.create('supplierPortal', false)

const getStatusTheme = async () => {
  return await dponetAPINotTreatError.get(
    `/client_portal_theme_companies/get_status_theme`,
  )
}

export default { getStatusTheme }
